require('underscore');
import { getDecimalSeparators, isNumber } from '../../misc/helpers';
import Membership from "../../misc/membership";

export default class BookListPage {
    constructor(studentDiscountUrl, linkCartUrl, language, membershipIsVisible, urlRouteMembershipChange, membershipFee) {
        if (typeof studentDiscountUrl === 'undefined' ||
            typeof linkCartUrl === 'undefined' ||
            typeof language === 'undefined' ||
            typeof membershipIsVisible === 'undefined' ||
            typeof urlRouteMembershipChange === 'undefined' ||
            typeof membershipFee === 'membershipFee'
        ) {
            console.warn('WARNING! Parameters missing - Could not initialize BooklistPage.'); // eslint-disable-line no-console
            return;
        }

        // more less toggling
        this.more = $('#school-description span.more');
        this.toggleMoreBtns = $('a.toggleMore');

        this.moreBtn = $('a.more');
        this.lessBtn = $('a.less');
        this.lessBtn.css('display', 'none'); // default
        this.more.css('display', 'none');

        this.toggleMoreBtns.bind('click', () => {
            this.toggleMore();
        });

        this.form = $('#booklist-form');

        this.clickableItems = $('.booklist__item--clickable');

        if (this.clickableItems.length > 0) {
            for (var i = 0; i <= this.clickableItems.length; i++) {
                var purchaseTypes = $(this.clickableItems[i]).find('.booklist__purchasetypes');

                if (purchaseTypes.length > 1) {
                    purchaseTypes.bind('click', (event) => {
                        event.stopPropagation();

                        if (event.target.tagName.toLowerCase() == 'span' && $(event.target).hasClass('info-button')) {
                            return;
                        }

                        var input = $(event.currentTarget).find('input.product-checkbox');

                        if (!input.prop('checked') && !input.prop('disabled')) {
                            input.prop('checked', true).change();
                        } else if (input.prop('checked')) {
                            if (input.data('uncheckable') === undefined && !input.prop('disabled')) {
                                input.prop('checked', false).change();
                            }
                        }
                    })
                }
            }

            this.clickableItems.on('click', event => {
                if (event.target.tagName.toLowerCase() == 'select' ||
                    event.target.tagName.toLowerCase() == 'a' ||
                    (event.target.tagName.toLowerCase() == 'span' && $(event.target).hasClass('info-button'))) {
                    return;
                }

                const currentTarget = $(event.currentTarget);

                var input = currentTarget.find('input.product-checkbox');
                var atLeastOneChecked = currentTarget.find('input.product-checkbox:checked')

                if (!input.prop('checked') && atLeastOneChecked.length == 0 && !$(input[0]).prop('disabled')) {
                    $(input[0]).prop('checked', true).change();
                } else if (input.prop('checked') || atLeastOneChecked.length > 0) {
                    if (input.data('uncheckable') === undefined && !input.prop('disabled')) {
                        input.prop('checked', false).change();
                    }
                }
            });

            this.clickableItems.find('select').bind('click', (event) => {
                event.stopPropagation()
            });
        }

        this.clickableItemRows = $('.booklist__item--clickable');

        if (this.clickableItemRows.length > 0) {
            for (var i = 0; i <= this.clickableItemRows.length; i++) {

                var purchaseTypes = $(this.clickableItemRows[i]).find('.product-list__purchasetypes');

                if (purchaseTypes.length > 1) {
                    purchaseTypes.bind('click', (event) => {
                        event.stopPropagation();

                        if (event.target.tagName.toLowerCase() == 'span' && $(event.target).hasClass('info-button')) {
                            return;
                        }

                        var input = $(event.currentTarget).find('input.product-checkbox');

                        if (!input.prop('checked') && !input.prop('disabled')) {
                            input.prop('checked', true).change();
                        } else if (input.prop('checked')) {
                            if (input.data('uncheckable') === undefined && !input.prop('disabled')) {
                                input.prop('checked', false).change();
                            }
                        }
                    })
                }
            }

            this.clickableItemRows.bind('click', (event) => {
                if (event.target.tagName.toLowerCase() == 'select' ||
                    event.target.tagName.toLowerCase() == 'a' ||
                    (event.target.tagName.toLowerCase() == 'span' && $(event.target).hasClass('info-button'))) {
                    return;
                }

                var input = $(event.currentTarget).find('input.product-checkbox');
                var atLeastOneChecked = $(event.currentTarget).find('input.product-checkbox:checked')

                if (!input.prop('checked') && atLeastOneChecked.length == 0 && !$(input[0]).prop('disabled')) {
                    $(input[0]).prop('checked', true).change();
                } else if (input.prop('checked') || atLeastOneChecked.length > 0) {
                    if (input.data('uncheckable') === undefined && !input.prop('disabled')) {
                        input.prop('checked', false).change();
                    }
                }
            })

            this.clickableItemRows.find('select').bind('click', (event) => { event.stopPropagation() })
        }

        $('a[id^="product-info-"]').on('click', event => {
            const currentTarget = $(event.currentTarget);
            var id = currentTarget.data('ean')

            const ean = currentTarget.data('original-ean');
            $('#product-info-dialog').html(`<div><h2 class="text-white text-center">${Resources.Global.Loading}...</h2></div>`);
            $.get(`/product/info?ean=${ean}`)
                .done((data) => {
                    $('#product-info-dialog').html(data);
                    var btn = $(`#modal-checkbox-new-${ean}`);
                    var checkboxBtn = $(`#CheckBoxNew-${id}`);
                    var buttonEan = checkboxBtn.data('ean');

                    const input = checkboxBtn.closest('.booklist__purchasetype').find(`input[data-ean="${buttonEan}"]`).first();
                    if (input.prop('checked')) {
                        btn.removeClass('btn-new');
                        btn.addClass('btn-new-outline');
                        btn.html(Resources.Cart.Remove)
                    } else {
                        btn.addClass('btn-new');
                        btn.removeClass('btn-new-outline');
                        btn.html(Resources.Booklist.FloatingCartOrderBtn)
                    }

                    btn.bind("click", () => {
                        checkboxBtn.click();
                        $('#product-info-modal').modal('hide');
                    });
                })
                .fail(() => {
                    // Give feedback
                    $('#product-info-dialog').html(`<div class="modal__content py-5"><p class="m-0 text-center">${Resources.Global.SomethingWentWrong}...</p></div>`);

                    // Autohide
                    setTimeout(() => {
                        $('#product-info-modal').modal('hide')
                    }, 4000);
                });
        })

        $('.add-to-list').on('click', event => {
            const target = $(event.currentTarget);
            const ean = target.data('ean');
            const input = target.closest('.booklist__purchasetype').find(`input[data-ean="${ean}"]`).first();
            let parentContainer = $(target).closest('.booklist__purchasetype-container--multiple').first();
            if (parentContainer.length > 0) {
                let checkboxes = $(parentContainer).find('input[type="checkbox"]');

                $.each(checkboxes, (index, checkbox) => {
                    // If checkbox is not the same as we clicked, uncheck it
                    if ($(checkbox).is($(input)) == false && $(checkbox).prop('checked')) {
                        $(`#${$(checkbox).data('sf')}-${$(checkbox).data('ean')}`).addClass('btn-new');
                        $(`#${$(checkbox).data('sf')}-${$(checkbox).data('ean')}`).removeClass('btn-new-outline');
                        $(`#${$(checkbox).data('sf')}-${$(checkbox).data('ean')}`).html(Resources.Booklist.FloatingCartOrderBtn);
                        $(checkbox).prop('checked', false)
                    }
                });
            }

            if (input.prop('checked')) {
                target.addClass('btn-new');
                target.removeClass('btn-new-outline');
                target.html(Resources.Booklist.FloatingCartOrderBtn)
                input.prop('checked', false).change();
            } else {
                target.removeClass('btn-new');
                target.addClass('btn-new-outline');
                target.html(Resources.Cart.Remove)
                input.prop('checked', true).change();
            }
        })

        //membership discount
        this.urlRouteMembershipChange = urlRouteMembershipChange;
        this.membershipFee = membershipFee;
        this.membershipIsVisible = membershipIsVisible;
        this.membershipTypeIsJoin = false;

        // student discount
        this.studentDiscountUrl = studentDiscountUrl;
        this.linkCartUrl = linkCartUrl;
        this.language = language;

        this.studentDeclaration = $('[name=\'IsStudentDiscountSelected\']');
        this.studentDiscount = this.studentDeclaration.first().prop('checked');

        this.priceElements = $('.product-list__price.product-list__price_from-to.dutch');
        this.studentDeclaration.on('change', (event) => {
            this.toggleStudentDiscount($(event.target));
        });

        // Uncheck the other checkbox for multiple checkbox options (buy or rental)
        this.multipleOptionsCheckboxes = $('.booklist__purchasetype-container--multiple input[type="checkbox"]');
        this.multipleOptionsCheckboxes.on('change', event => {
            this.uncheckMultipleOptions($(event.currentTarget));
        });

        this.totalItemsList = $('.list-items').length;
        $('#total-items').html(this.totalItemsList);

        // sidebar with info on the amount of selected stuff
        this.amountNew = 0;
        this.amountRequired = 0;

        this.selectedRequiredItems = $('#selected-required-items');

        // discount and cart calculations (product checkbox: data-ean, data-dutch, data-price)
        this.dutchBooks = 0; // dutch books amount

        const separators = getDecimalSeparators();

        this.subtotalBooklistContainer = $('#amount-subtotal'); // booklist subtotal without discount
        var booklistTotalText = this.subtotalBooklistContainer.first().text();
        if (!isNumber(booklistTotalText)) {
            this.booklistTotal = parseFloat(booklistTotalText.replace(separators.ToReplace, separators.ReplaceWith));
        } else {
            this.booklistTotal = parseFloat(booklistTotalText);
        }

        this.booklistDiscount = $('#booklist-discount'); // discount on booklist subtotal 
        var booklistDiscountText = this.booklistDiscount.first().text();
        if (!isNumber(booklistDiscountText)) {
            this.booklistDiscount = parseFloat(booklistDiscountText.replace(separators.ToReplace, separators.ReplaceWith));
        } else {
            this.booklistDiscount = parseFloat(booklistDiscountText);
        }

        this.shippingCostsContainer = $('#shippingCosts'); // shippingCosts
        var shippingCostsText = this.shippingCostsContainer.first().text();
        if (!isNumber(shippingCostsText)) {
            this.shippingCosts = parseFloat(shippingCostsText.replace(separators.ToReplace, separators.ReplaceWith));
            if (isNaN(this.shippingCosts)) {
                this.shippingCosts = 0.0;
            }
        } else {
            this.shippingCosts = parseFloat(shippingCostsText);
        }

        this.totalExclVAT = 0;
        this.totalExclVATContainer = $('.price-total-excl-vat');
        this.totalLowVAT = 0;
        this.totalLowVATContainer = $('.total-low-vat');
        this.totalHighVAT = 0;
        this.totalHighVATContainer = $('.total-high-vat');
        this.totalContainer = $('.floating-cart__body .amount-wrapper');
        this.discount = 0;
        this.discountContainer = $('#discount-total .total-discount');
        this.amountBooklist = 0;
        this.quantityContainer = $('#selected-items');

        this.addedToPrice = [];

        this.products = $('.product-checkbox');

        this.products.bind('change', () => {
            this.calculateDiscounts();
        });

        this.calculateDiscounts();

        // booklist item specific
        this.itemMoreToggleBtns = $('.item-more-toggle');
        this.itemMoreToggleBtns.bind('click', event => {
            const id = $(event.target).data('item-id');
            const show = $(event.target).data('item-show');
            if (show) {
                $(`.item-more-toggle.item-more.${id}`).hide();
                $(`.collapse.${id}`).show();
            } else {
                $(`.item-more-toggle.item-more.${id}`).show();
                $(`.collapse.${id}`).hide();
            }
            return false;
        });

        // check for duplicate items on the list
        this.checkDuplicatePresence();

        this.products.change(event => {
            BookListPage.showIsNecessaryMessage($(event.target)[0], $(event.target).data('unique'));
        });

        if (typeof this.membershipIsVisible !== 'undefined' && this.membershipIsVisible === true) {
            //Init Membership object
            const membership = new Membership(this.membershipIsVisible, this.studentDiscount, this.urlRouteMembershipChange, this.linkCartUrl);

            const membershipRadios = $("input[dataMembership]");
            membershipRadios.change(event => {
                membershipRadios.filter(`[dataMembership='${$(event.target).attr("dataMembership")}']`).prop("checked", true);
                this.membershipDiscountChange(membership, $(event.target).attr("dataMembership"))
            });

            this.membershipDiscountChange(membership, $(this.initMembership(membershipRadios)).attr("dataMembership"));
        }
    }

    initDiscount() {
        let el = null;
        $.each(this.studentDeclaration, function (key, value) {
            if ($(value).prop('checked')) {
                el = value;
            }
        });

        return el;
    }

    initMembership(membershipRadios) {
        let el = null;

        $.each(membershipRadios, function (key, value) {
            if ($(value).prop('checked')) {
                el = value;
            }
        });

        return el;
    }

    setDiscountVisualElements(discountIsActive) {
        if (this.membershipIsVisible) {
            const membership = new Membership(this.membershipIsVisible, discountIsActive, this.urlRouteMembershipChange, this.linkCartUrl);
            this.priceElements = membership.overridePriceElements();
        }

        if (discountIsActive) {
            this.priceElements.removeClass('price-override');
        } else {
            this.priceElements.addClass('price-override');
        }
    }

    membershipDiscountChange(membership, membershipType) {
        if (typeof membershipType !== 'undefined' && membershipType !== null) {
            $('#studentMembershipValidation').css('display', 'none');
            this.studentDiscount = membership.submitMembershipChange(membershipType);
            if (membership.membershipTypeIsJoin(membershipType)) {
                $('#membershipDiscount').show();
                this.membershipTypeIsJoin = true;
            } else {
                $('#membershipDiscount').hide();
                this.membershipTypeIsJoin = false;
            }

            this.setDiscountVisualElements(this.studentDiscount);
            this.calculateDiscounts();
        } else {
            $('#membershipDiscount').hide();
            this.membershipTypeIsJoin = false;
        }
    }

    checkDuplicatePresence() {
        $.each(this.products, (index, value) => {
            const el = $(value);
            const ean = el.data('ean');
            if (typeof ean === 'number') {
                if ($(`.item-presence-${ean}`).length > 1) {
                    $(`.item-presence-${ean}`).show();
                }
            }
        });
    }

    getProductsByEan(ean) {
        const eanProducts = {
            elements: [],
            hasChecked: false
        };
        $.each(this.products, (index, value) => {
            const el = $(value);
            const productEan = el.data('ean');
            if (ean !== undefined && productEan === ean) {
                eanProducts.elements.push(el);
                if (el.prop('checked')) {
                    eanProducts.hasChecked = true;
                }
            }
        });
        return eanProducts;
    } 

    checkItem(input) {
        const ean = input.data('ean');
        const eanProducts = this.getProductsByEan(ean);

        if (eanProducts.elements.length > 1 && !$(eanProducts.elements[0]).prop('disabled')) {
            $(eanProducts.elements[0]).prop('checked', true);

            if ($(eanProducts.elements[0]).hasClass('product-checkbox')) {
                $(eanProducts.elements[0]).change();
            }

            BookListPage.showIsNecessaryMessage(eanProducts.elements[0][0], eanProducts.elements[0].data('unique'));
        }
        else if (!input.prop('disabled')) {
            input.prop('checked', true);

            if (input.hasClass('product-checkbox')) {
                input.change();
            }
        }
    }

    uncheckMultipleOptions(input) {
        let parent = $(input).parents('.booklist__purchasetype-container--multiple').first();
        let checkboxes = $(parent).find('input[type="checkbox"]');

        $.each(checkboxes, (index, checkbox) => {
            // If checkbox is not the same as we clicked, uncheck it
            if ($(checkbox).is($(input)) == false) {
                $(checkbox).prop('checked', false);
            }
        });
    }

    reset() {
        $.each(this.products, (index, value) => {
            if ($(value).prop('checked')) {
                $(value).prop('checked', false);
            }
        });
    }

    AddToBooklistTotal(price, priceExclVAT, ean) {
        if (!_.includes(this.addedToPrice)) {
            if (priceExclVAT > 0) {
                const vatPercentage = (price / priceExclVAT - 1) * 100;
                if (vatPercentage > 5 && vatPercentage < 7) {
                    this.totalLowVAT = this.totalLowVAT + (price - priceExclVAT);
                } else {
                    this.totalHighVAT = this.totalHighVAT + (price - priceExclVAT);
                }
            }
            this.totalExclVAT = this.totalExclVAT + priceExclVAT;
            this.booklistTotal = this.booklistTotal + price;
            this.addedToPrice.push(ean);
        }
    }

    calculateDiscounts() {
        // first count the dutchbooks
        this.dutchBooks = $('.product-checkbox[data-purchasetype="0"][data-dutch="True"]:checked').length;

        if (this.dutchBooks > 1) {
            this.form.addClass('double-dutch');
        } else {
            this.form.removeClass('double-dutch');
        }

        this.totalLowVAT = 0;
        this.totalHighVAT = 0;
        this.totalExclVAT = 0;

        this.booklistTotal = 0;
        this.amountBooklist = 0;
        this.discount = 0;

        this.addedToPrice = [];

        const separators = getDecimalSeparators();

        $.each(this.products, (index, value) => {
            const el = $(value);
            const productEan = el.data('ean');
            const productLumpsum = el.data('lumpsum') === 'True';

            if (el.attr('data-purchasetype') && el.data('purchasetype') === 0) {
                // new?
                if (el.prop('checked')) {
                    // and checked?
                    this.amountBooklist += 1;

                    const listdiscountalreadyapplied = el.data('haslistdiscountapplied') === 'True';
                    let priceFrom = productLumpsum ? 0 : el.data('price-from');
                    let priceTo = productLumpsum ? 0 : el.data('price-to');

                    // todo extract to function
                    if (!isNumber(priceFrom)) {
                        priceFrom = parseFloat(el.data('price-from').replace(separators.ToReplace, separators.ReplaceWith));
                    } else {
                        priceFrom = parseFloat(priceFrom);
                    }
                    if (!isNumber(priceTo)) {
                        priceTo = parseFloat(el.data('price-to').replace(separators.ToReplace, separators.ReplaceWith));
                    } else {
                        priceTo = parseFloat(priceTo);
                    }

                    let priceToExclVAT = el.data('price-excluding-vat');
                    if (priceToExclVAT !== undefined) {
                        if (!isNumber(priceToExclVAT)) {
                            priceToExclVAT = parseFloat(el.data('price-excluding-vat')
                                .replace(separators.ToReplace, separators.ReplaceWith));
                        } else {
                            priceToExclVAT = parseFloat(priceToExclVAT);
                        }
                    }

                    if (el.data('dutch') === 'True' && !listdiscountalreadyapplied) {
                        const unique = el.data('unique');

                        if (this.dutchBooks > 1 && this.studentDiscount) {
                            this.togglePriceFromTo(priceFrom, priceTo, el);
                        } else {
                            // show price from
                            $(`.price-from.${unique}`)
                                .removeClass('old')
                                .addClass('current');
                            $(`.price-to.${unique}`)
                                .removeClass('current')
                                .addClass('old');
                        }
                    } else if (this.membershipIsVisible && this.studentDiscount && !listdiscountalreadyapplied) {
                        this.togglePriceFromTo(priceFrom, priceTo, el);
                    } else if (priceFrom !== priceTo && (listdiscountalreadyapplied || !this.membershipIsVisible)) {
                        // not dutch, add the items
                        // also add the discount
                        this.discount += priceFrom - priceTo;
                    }

                    _.bind(this.AddToBooklistTotal, this, priceFrom, priceToExclVAT, productEan)();
                }
                else if (el.data('dutch') === 'True') {
                    const isUnique = el.data('unique');
                    $(`.price-from.${isUnique}`)
                        .removeClass('old')
                        .addClass('current');
                    $(`.price-to.${isUnique}`)
                        .removeClass('current')
                        .addClass('old');
                }
            } else if (el.prop('checked')) {
                let price = productLumpsum ? 0 : el.data('price-to');
                try {
                    if (!isNumber(price)) {
                        price = parseFloat(price.replace(separators.ToReplace, separators.ReplaceWith));

                        _.bind(this.AddToBooklistTotal, this, price, 0, productEan)();

                        this.amountBooklist += 1;
                    } else if (el.attr('data-purchasetype') && el.data('purchasetype') === 2) {
                        this.amountBooklist += 1;
                    }
                } catch (e) {
                    // not catching anything to ignore errors?
                }
            }
        });

        this.setPrices();
        this.selectedRequiredItems.html($('.booklist__item--required input[type=checkbox]:checked').length);

        this.setDiscountVisualElements(this.studentDiscount);
    }

    setPrices() {
        const separators = getDecimalSeparators(this.language === 'nl');
        let subtotal = this.booklistTotal;
        let discount = this.discount;
        let shippingCosts = this.shippingCosts;
        let membershipFee = this.membershipFee;

        if (!isNumber(subtotal)) {
            subtotal = subtotal.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith);
        }

        if (!isNumber(discount)) {
            discount = discount.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith);
        }

        if (this.membershipTypeIsJoin && this.membershipIsVisible) {
            if (!isNumber(membershipFee)) {
                membershipFee = membershipFee.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith);
            }
        } else {
            membershipFee = 0;
        }

        const total = (subtotal + membershipFee) + shippingCosts - discount;
        const totalFormatted = total.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith);

        this.discountContainer.html(this.discount.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith));

        this.quantityContainer.html(this.amountBooklist);
        this.totalHighVATContainer.html(this.totalHighVAT.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith));
        this.totalLowVATContainer.html(this.totalLowVAT.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith));
        this.totalExclVATContainer.html(this.totalExclVAT.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith));
        this.subtotalBooklistContainer.html(subtotal.toFixed(2).replace(separators.ToReplace, separators.ReplaceWith));

        this.totalContainer.html(totalFormatted);
    }

    toggleMore() {
        this.more.toggle();
        if (this.more.css('display') === 'inline') {
            this.lessBtn.css('display', 'inline');
            this.moreBtn.css('display', 'none');
        } else {
            this.lessBtn.css('display', 'none');
            this.moreBtn.css('display', 'inline');
        }
    }

    toggleStudentDiscount(element) {
        const discount = element.val() === 'True' ? true : false;

        $.get(`${this.studentDiscountUrl}?discount=${discount}`)
            .done(() => {
                $('#link-cart').load(this.linkCartUrl);
                this.studentDiscount = discount;
                if (discount) {
                    this.form.addClass('discount-enabled');
                } else {
                    this.form.removeClass('discount-enabled');
                }
                element.prop('checked');
                this.calculateDiscounts();
            })
            .fail(() => {
                // reverse the checked since something went wrong
                element.prop('checked');
                this.studentDiscount = !discount;
                this.setDiscountVisualElements(this.studentDiscount);
            });
    }

    static showIsNecessaryMessage(element, forId) {
        const isChecked = element.checked;
        const selector = `.required-message-${forId}`;

        if (isChecked) {
            $(selector).hide();
        }
        else {
            let otherOptionChecked = false;
            $(`#purchasetype-options${forId} input:checked`).each(purchasetypeOption => {
                if (purchasetypeOption !== element) {
                    otherOptionChecked = true;
                }
            });
            if (!otherOptionChecked) {
                $(selector).show();
            }
        }
    }

    togglePriceFromTo(priceFrom, priceTo, el) {
        const unique = el.data('unique');
        if (priceTo !== priceFrom) {
            // only toggle if prices are different from eachother
            $(`.price-from.${unique}`)
                .removeClass('current')
                .addClass('old');
            $(`.price-to.${unique}`)
                .removeClass('old')
                .addClass('current');
            this.discount += priceFrom - priceTo;
        } else {
            $(`.price-from.${unique}`);
        }
    }
}